// business.reducer.ts
import { createFeature, createReducer, on } from '@ngrx/store'
import { TaskLogState } from './task-log.state'
import { activityLogActions } from './task-log.actions'

export const initialState: TaskLogState = {
  totalCount: 0,
  tasklogs: [],
  totalBusinessLogCount: 0,
  businessTasklogs: [],
  loading: false,
  error: null
}

// Create the task logs reducer
export const tasklogReducer = createReducer(
  initialState,
  on(activityLogActions.loadMyLogs, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(activityLogActions.loadMyLogsSuccess, (state, { totalCount, tasklogs }) => ({
    ...state,
    totalCount,
    tasklogs,
    loading: false,
    error: null
  })),
  on(activityLogActions.loadMyLogsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(activityLogActions.loadBusinessLogs, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(
    activityLogActions.loadBusinessLogsSuccess,
    (state, { totalBusinessLogCount, businessTasklogs }) => ({
      ...state,
      totalBusinessLogCount,
      businessTasklogs,
      loading: false,
      error: null
    })
  ),
  on(activityLogActions.loadBusinessLogsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  }))
)

// Create the feature for the tasklogs state
export const taskLogFeature = createFeature({
  name: 'taskLog', // Feature name
  reducer: tasklogReducer
})
export const {
  name,
  reducer,
  selectTasklogs,
  selectTotalCount,
  selectBusinessTasklogs,
  selectTotalBusinessLogCount,
  selectLoading,
  selectError
} = taskLogFeature
